import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptorPortal";
import fetchWithNoBearer from "../auth/FetchInterceptorPortalWithNoBearer";

const PortalService = {};

PortalService.getCapcha = function (type, tenant_code, year) {
  return fetch({
    url: `${env.API_MSP}/invoice-codes/captcha`,
    method: "get",
  });
};
PortalService.searchCodePortal = function (payload) {
  return fetch({
    url: `${env.API_MSP}/invoice-codes/verify`,
    method: "post",
    data: payload,
  });
};
PortalService.getSearchResult = function (payload) {
  return fetch({
    url: `${env.API_MSP}/invoice-codes/preview`,
    method: "post",
    data: {
      id: payload.id,
    },
    headers: {
      "Invoice-Token": payload.token,
    },
  });
};
PortalService.downloadFile = function (payload) {
  const configParams = {
    ids: payload.ids,
    file_type: payload.file_type,
  };
  return fetch({
    url: `${env.API_MSP}/invoice-codes/download`,
    method: "POST",
    responseType: "blob",
    data: configParams,
    headers: {
      "Invoice-Token": payload.token,
    },
  });
};

export default PortalService;
